import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  //console.log("product",product)
 
  return (
    <Card className="card">
        <CardMedia
        component = "img"
        image={product['image']}
        alt={product["name"]}
        />
        <CardContent>
          <Typography>{product["name"]}</Typography>
          <Typography fontWeight="700" paddingY="0.5rem">${product["cost"]}</Typography>
          <Rating name="read-only" precision={0.5} value={product["rating"]} readOnly />
        </CardContent>
        <CardActions>
          <Button fullWidth variant ="contained" startIcon={<AddShoppingCartOutlined />}  onClick={handleAddToCart} >ADD TO CART</Button>
        </CardActions>       
    </Card>
  );
};

export default ProductCard;
